// Export post components
export { default as RelatedPosts } from './RelatedPosts';
